<template>
  <main id="main">
    <Loading :isProcessing="isProcessing"></Loading>
    <DiagCorpHeader
      :corpName="corpName"
      :corporateFeatureInfoLabels="corporateFeatureInfoLabels"
      :corporateSelectable="isAdmin"
      :manageCorpName="manageCorpName"
      :isAdmin="isAdmin"
      :isDiagAvailablePlan="isDiagAvailablePlan"
      @select-corporate="emitSelectCorpList"
    ></DiagCorpHeader>
    <DiagHeaderNavigation
      :answeredDiagResultItemsCountTotal="this.diagResultSections.answeredCount"
      :diagItemsCountTotal="this.diagResultSections.totalCount"
    ></DiagHeaderNavigation>
    <div class="l-contents">
      <div class="l-contentsBox  no-border">
        <DiagNavigation
          :isAdmin="isAdmin"
        ></DiagNavigation>
        <div class="l-contentsBox">
          <div class="l-contentsSection">
            <p class="l-text">「監査フォーム」は企業の状況を確認するための質問フォームです。<br>
              回答することで、企業のリスクを洗い出すことができます。<br>
              回答するカテゴリをクリックしてください。
            </p>
          </div>
          <div class="answer_number">
            <p>回答数<span>{{ diagResultSections.answeredDiagResultItemsCountTotal }} </span> / {{ diagResultSections.diagItemsCountTotal }}</p>
          </div>
          <div class="answer-list">
            <div v-for="diagSection in diagResultSections.diagSections" :key="diagSection.section_id">
              <a class="answer-item is-complete" @click="goAnswerInput(diagSection.section_id)">
                <div class="ttl">{{ diagSection.sort_order }}. {{ diagSection.section_nm }}</div>
                <div class="response">
                  <p>回答数</p>
                  <div class="progress_bar"><span :style="'width: ' + Math.floor(diagSection.answer_rate) + '%;'"></span></div>
                  <p class="number">{{ Math.floor(diagSection.answer_rate) }}%（<span>{{ diagSection.answered_diag_result_items_count }}</span>/{{ diagSection.diag_items_count }}）</p>
                  <span style="color: red;" v-if="diagSection.has_diag_changed">
                    ★チェック項目が追加・変更されました。
                  </span>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <transition name="tutorialmodal-fade">
      <DiagSectionListTutorial
        v-show="isShowTutorial"
        @close-tutorial-modal="showTutorialModal(false)"
      ></DiagSectionListTutorial>
    </transition>
  </main>
</template>

<script>
import Loading from '@/components/parts/common/Loading.vue';
import DiagCorpHeader from '@/components/parts/diag/DiagCorpHeader.vue';
import DiagHeaderNavigation from '@/components/parts/diag/DiagHeaderNavigation.vue';
import DiagNavigation from '@/components/parts/diag/DiagNavigation.vue';
import DiagSectionListTutorial from '@/components/parts/tutorial/DiagSectionListTutorial.vue';

export default {
  components: {
    Loading,
    DiagCorpHeader,
    DiagHeaderNavigation,
    DiagNavigation,
    DiagSectionListTutorial,
  },
  data() {
    return {
      isProcessing: false,
      isAdmin: false,
      isDiagAvailablePlan: false,
      diagResultSections: {
        corporate: {},
        diagCourse: {
          courseName: ""
        },
        diagSections: [
          {
            diagItems: [],
          }
        ],
        score: 0,
        totalScore: 0,
        answeredCount: 0,
        totalCount: 0,
      },
      isShowTutorial: false,
    }
  },
  computed: {
    diagResultId() {
      return this.$store.getters['diag/getDiagResultId'];
    },
    corpId() {
      return this.$store.getters['diag/getCorpId'];
    },
    diagCourseId() {
      return this.$store.getters['diag/getDiagCourseId'];
    },
    corpName() {
      return this.$store.getters['diag/getCorpName'];
    },
    corporateFeatureInfoLabels() {
      return this.$store.getters['diag/getCorporateFeatureInfoLabels'];
    },
    manageCorpName() {
      return this.$store.getters['auth/getUser'].manageCorpNm;
    },
  },
  watch: {
    async corpId() {
      this.$store.dispatch('diag/setDiagResultId', null);
      this.$router.push({ name: 'diag-top' });
    }
  },
  created: async function() {
    this.isProcessing = true;
    const authority = await this.$store.dispatch('auth/getAuthority')
    this.isAdmin = authority.isAdmin;
    this.isDiagAvailablePlan = authority.isDiagAvailablePlan;

    await this.getDiagResultSections(this.diagResultId, this.diagCourseId, this.corpId);

    this.isProcessing = false;

this.showTutorialModal(this.$store.getters['auth/getUser'].tutorial.isShowDiagSectionTutorial);
  },
  methods: {
    async getDiagResultSections(diagResultId, diagCourseId, corpId) {
      this.isProcessing = true;
      let res = await this.$axios.post('/ld/api/diag/getDiagResultSections', {
        diagResultId: diagResultId,
        diagCourseId: diagCourseId,
        corpId: corpId,
      });
      if (res) {
        this.diagResultSections = res.data.diagResultSections;
        this.$store.dispatch('diag/setDiagResultId', this.diagResultSections.diagResultId);
        this.$store.dispatch('diag/setTitle', this.diagResultSections.title);
        this.$store.dispatch('diag/setDiagCourseName', this.diagResultSections.diagCourse.courseName);
      }
      this.isProcessing = false;
    },
    goAnswerInput(sectionId) {
      this.$store.dispatch('diag/setDiagResultId', this.diagResultId);
      this.$store.dispatch('diag/setDiagCourseId', this.diagResultSections.diagCourseId);
      this.$store.dispatch('diag/setSectionId', sectionId);
      this.$router.push({
        name: 'diag-answer-input',
        query: {
          diagCourseId: this.diagResultSections.diagCourseId,
          sectionId: sectionId
        }
      });
    },
    goDiagManagementList(diagResultId) {
      this.$store.dispatch('diag/setDiagResultId', diagResultId);
      this.$router.push({ name: 'diag-management-list' });
    },
    goDiagList() {
      this.$store.dispatch('diag/setCorpId', this.corpId);
      this.$router.push({ name: 'diag-top' });
    },
    goTaskList(diagResultId) {
      this.$store.dispatch('diag/setDiagResultId', diagResultId);
      this.$router.push({ name: 'task-list' });
    },
    emitSelectCorpList(params) {
      this.$store.dispatch('diag/setCorpId', params.corpId);
      this.$store.dispatch('diag/setCorpName', params.corpNm);
    },
    showTutorialModal(value) {
      this.isShowTutorial = value;
    }
  }
}

</script>

<style scoped>
.tutorialmodal-fade-enter-active {
  transition: all .2s ease;
}
.tutorialmodal-fade-leave-active {
  transition: all .2s ease;
}
.tutorialmodal-fade-enter {
  transform: translateY(-50px);
  opacity: 0;
}
.tutorialmodal-fade-leave-to {
  transform: translateY(-50px);
  opacity: 0;
}
</style>
